import { render, staticRenderFns } from "./DrawPrizeModuleModal.vue?vue&type=template&id=09b452d4&"
import script from "./DrawPrizeModuleModal.vue?vue&type=script&lang=js&"
export * from "./DrawPrizeModuleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports